export default __webpack_public_path__ + "images/smallLogo.685fda0fcf44fd6521e9a29307010d71.png";